import log from '@pexip/logger';
import {setLogger} from '@pexip/media-control';
import {setLogger as setMediaLogger} from '@pexip/media';

export const logger = log.child({name: 'infinity-connect'});

setLogger(log.child({name: 'media-control'}));
setMediaLogger(log.child({name: 'media'}));
